import { ModalFactory } from '@rendora/common/features/modals/factory';
import { Preference, usePayment } from '@rendora/common/features/payment/store';
import { getBuriedService } from '@rendora/common/services/buried/index';
import { getI18nService } from '@rendora/common/services/i18n';
import { isCN } from '@rendora/common/utils/config';
import RightCompare from './ui/RightCompare.vue';

const symbol = Symbol('right-compare-modal');

export const showRightCompareModal = (preference?: Preference) => {
  const i18nService = getI18nService();
  const $t = i18nService.t;
  const buriedService = getBuriedService();
  buriedService?.track('youyan_platform_pay_page_show');

  const paymentStore = usePayment();

  if (preference) {
    paymentStore.preference = preference;
  }

  if (ModalFactory.getInstance(symbol)) {
    return;
  }

  ModalFactory.clear();

  return ModalFactory.create(
    {
      title: $t('fu-fei-ding-yue'),
      width: isCN() ? '1014px' : '800px',
      content: <RightCompare />,
    },
    symbol,
  );
};
